import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aqar21',
  templateUrl: './aqar21.component.html',
  styleUrls: ['./aqar21.component.scss']
})
export class Aqar21Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
